import {ADMINS_REQUEST, ADMINS_SUCCESS, ADMINS_FAILURE} from '../actions';
import {STORE_ADMIN_REQUEST, STORE_ADMIN_SUCCESS, STORE_ADMIN_FAILURE} from '../actions';
import {UPDATE_ADMIN_REQUEST, UPDATE_ADMIN_SUCCESS, UPDATE_ADMIN_FAILURE} from '../actions';
import adminReducer from './admin';

export const ADMINS_INITIAL_STATE = {
    isFetching: false,
    data: [],
    links: {},
    meta: {},
    error: null
};

const updateAdmin = (state, action) => {
    let {data} = state;
    const {id} = action;
    const admin = data.find(b => b.id === id);
    data.splice(data.indexOf(admin), 1);
    const reduced = adminReducer(admin, action);
    data = [...state.data, reduced];

    return {...state, data};
};

const adminsReducers = {
    [ADMINS_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [ADMINS_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [ADMINS_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [STORE_ADMIN_REQUEST]: (state, action) => {
        const admin = adminReducer(undefined, action);
        const data = [...state.data.filter(b => !b.draft), admin];

        return {...state, data};
    },
    [STORE_ADMIN_SUCCESS]: (state, action) => {
        let {data} = state;
        const admin = data.find(b => b.draft);
        data.splice(data.indexOf(admin), 1);
        const reduced = adminReducer(admin, action);
        data = [...data, reduced];

        return {...state, data};
    },
    [STORE_ADMIN_FAILURE]: (state, action) => {
        let {data} = state;
        const admin = data.find(b => b.draft);
        data.splice(data.indexOf(admin), 1);
        const reduced = adminReducer(admin, action);
        data = [...state.data, reduced];

        return {...state, data};
    },
    [UPDATE_ADMIN_REQUEST]: updateAdmin,
    [UPDATE_ADMIN_SUCCESS]: updateAdmin,
    [UPDATE_ADMIN_FAILURE]: updateAdmin
};

export default function admins(state = ADMINS_INITIAL_STATE, action) {
    let reducer = adminsReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/admins.js